/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BookVersionListItemResponseModel model module.
 * @module model/BookVersionListItemResponseModel
 * @version v1.0.0
 */
class BookVersionListItemResponseModel {
    /**
     * Constructs a new <code>BookVersionListItemResponseModel</code>.
     * @alias module:model/BookVersionListItemResponseModel
     */
    constructor() { 
        
        BookVersionListItemResponseModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookVersionListItemResponseModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookVersionListItemResponseModel} obj Optional instance to populate.
     * @return {module:model/BookVersionListItemResponseModel} The populated <code>BookVersionListItemResponseModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookVersionListItemResponseModel();

            if (data.hasOwnProperty('bookId')) {
                obj['bookId'] = ApiClient.convertToType(data['bookId'], 'String');
            }
            if (data.hasOwnProperty('root')) {
                obj['root'] = ApiClient.convertToType(data['root'], 'Boolean');
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
        }
        return obj;
    }


}

/**
 * book Id
 * @member {String} bookId
 */
BookVersionListItemResponseModel.prototype['bookId'] = undefined;

/**
 * @member {Boolean} root
 */
BookVersionListItemResponseModel.prototype['root'] = undefined;

/**
 * version
 * @member {String} version
 */
BookVersionListItemResponseModel.prototype['version'] = undefined;






export default BookVersionListItemResponseModel;

